import {jwtstore} from "../api/JWTStore";
import jwtDecode, {JwtPayload} from "jwt-decode";

export class TenantDetector {

    static getTenantKey(): string {
        const atlassianJwt = jwtstore.jwt;

        if (atlassianJwt === '') {
            return "";
        }

        const jwtDecoded = jwtDecode<JwtPayload>(atlassianJwt);
        return jwtDecoded.iss ?? "";
    }
}
